module.exports = {
  siteTitle: 'Taranui', // <title>
  manifestName: 'newage',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/gatsby-starter-newage/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  socialLinks: [
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/company/taranui-com',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/sharingdistance',
    },
    {
      icon: 'fa-instagram',
      name: 'Instagram',
      url: 'https://www.instagram.com/taranui_sharingdistances',
    },
    {
      icon: 'fa-youtube',
      name: 'YouTube',
      url:
        'https://www.youtube.com/channel/UC7DR67VR4i9ZOl-CYBR8isg?sub_confirmation=1',
    },
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: 'https://www.facebook.com/sharingdistances',
    },
  ],
  features: [
    {
      title: 'Bucketlist',
      description: 'What is important for you – bucket your travel list',
      icon: 'icon bucketlist',
    },
    {
      title: 'Review',
      description: 'Rate the places you likes – be an audacious explorer',
      icon: 'icon rate',
    },
    {
      title: 'Profile and Places',
      description: 'Capture & Share – the happiness is real when it is shared',
      icon: 'icon place',
    },
    {
      title: 'Messaging',
      description:
        'Ask Taranuis for tips and tell the travellers in the community about your discoveries',
      icon: 'icon chat',
    },
  ],
};
